import { CommonModule } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ContentChild,
  TemplateRef,
  computed,
  input,
} from '@angular/core'
import { ActivatedRoute, RouterModule } from '@angular/router'
import { OcBreadcrumbComponent, OcBreadcrumbItem, OcStyleThemeType } from 'otimus-library'
import { Observable } from 'rxjs'
import { DrawerComponent } from 'src/app/components/drawer/drawer.component'
import { BreadcrumbService } from 'src/app/services/breadcrumb.service'
import { ContainerService } from 'src/app/services/container.service'
import { InternationalizationService } from 'src/app/services/internationalization.service'
import { MobileService } from 'src/app/services/mobile.service'
import { StyleThemeService } from 'src/app/services/style-theme.service'

@Component({
  selector: 'app-page-container',
  imports: [CommonModule, RouterModule, DrawerComponent, OcBreadcrumbComponent],
  templateUrl: './page-container.component.html',
  styleUrl: './page-container.component.scss',
  standalone: true,
})
export class PageContainerComponent implements AfterViewInit {
  @ContentChild('containerButton') containerButtonTpl!: TemplateRef<any>
  readonly breadcrumbPath = input<OcBreadcrumbItem[]>([])
  drawerOpen: boolean = false
  style: OcStyleThemeType = 'otimus'
  buttonTemplate$: Observable<TemplateRef<any> | null>

  readonly effectiveBreadcrumb = computed<OcBreadcrumbItem[]>(() =>
    this.breadcrumbPath().length > 0 ? this.breadcrumbPath() : this.breadcrumbService.path()
  )

  constructor(
    protected cdr: ChangeDetectorRef,
    public mobileService: MobileService,
    public container: ContainerService,
    public route: ActivatedRoute,
    public translation: InternationalizationService,
    public styleThemeService: StyleThemeService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.buttonTemplate$ = this.container.buttonTemplate$
  }

  openDrawer(): void {
    this.drawerOpen = true
  }

  closeDrawer(): void {
    this.drawerOpen = false
  }

  removePagePaddingByParam(): void {
    this.route.queryParams.subscribe((params: any) => {
      if (params.pagePadding === 'false') {
        this.container.removePadding = true
      }

      if (this.container.goBackBtn) {
        this.container.goBackBtn = !(params.hideGoBackButton === 'true')
      }
    })
  }

  ngAfterViewInit(): void {
    this.removePagePaddingByParam()
    this.getStyle()
    this.cdr.detectChanges()
  }

  getTranslation(code: string): string {
    return this.translation.getTranslation(code)
  }

  getStyle(): void {
    const style = localStorage.getItem('@oc-lib-style_theme')

    if (!style || !['otimus', 'shui', 'semantic'].includes(style)) {
      return
    }

    this.style = style as OcStyleThemeType
  }
}
